var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgProfileDefault = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  "aria-hidden": true,
  viewBox: "0 0 14 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.781 9.5c-.906 0-1.312.5-2.78.5-1.5 0-1.907-.5-2.813-.5C1.875 9.5 0 11.406 0 13.719v.781c0 .844.656 1.5 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-.781C14 11.406 12.094 9.5 9.781 9.5m2.72 5h-11v-.781C1.5 12.219 2.687 11 4.187 11c.468 0 1.187.5 2.812.5 1.594 0 2.313-.5 2.781-.5a2.72 2.72 0 0 1 2.72 2.719zM7 9c2.468 0 4.5-2 4.5-4.5C11.5 2.031 9.468 0 7 0 4.5 0 2.5 2.031 2.5 4.5 2.5 7 4.5 9 7 9m0-7.5c1.624 0 3 1.375 3 3 0 1.656-1.376 3-3 3a3 3 0 0 1-3-3c0-1.625 1.343-3 3-3"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfileDefault);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;